// Deep value comparison for the always-editable form pattern's dirty-tracking.
// Arrays are compared order-insensitively (form value sets like contact-list ids
// or selected options don't care about order); plain objects compare key-by-key.
// Build a `current` object from live state and a `baseline` from the loaded
// record, then `isDirty = !formEqual(current, baseline)`.
export function formEqual(a, b) {
  if (a === b) return true;

  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) return false;
    const sa = a.map((x) => JSON.stringify(x)).sort();
    const sb = b.map((x) => JSON.stringify(x)).sort();
    return sa.every((v, i) => v === sb[i]);
  }

  if (a && b && typeof a === "object" && typeof b === "object") {
    const ka = Object.keys(a);
    const kb = Object.keys(b);
    if (ka.length !== kb.length) return false;
    return ka.every((k) => formEqual(a[k], b[k]));
  }

  return a === b;
}
